import React from 'react'
import service_block_shape from '../../assets/images/shape/service-block-shape.png';
const SubServices = () => {
  return (
    <>
      <section className="case-section bg-thm1 pt-120 pb-120">
        <div className="auto-container">
          <div className="row g-0">
            <div
              className="col-md-6 col-xl-4 wow fadeInUp"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="service-block-two">
                <div className="inner-box border-0">
                  <div className="icon">
                    <svg
                      width={96}
                      height={96}
                      viewBox="0 0 96 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M36 12V36L22 70C20 76 24 84 31 84H65C72 84 76 76 74 70L60 36V12"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M34 12H62"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M30 66H66"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="content-box">
                    <h4 className="title">Material Testing Services – Soil</h4>
                    <p className="text text-clamp-3">
                      Soil is a naturally occurring material with highly
                      variable engineering properties that directly influence
                      the performance and safety of civil and structural works.
                      Soil Material Testing must figure out the physical,
                      mechanical, and chemical characteristics of soil to ensure
                      it is suitable for its intended engineering application.
                    </p>
                    <a
                      className="btn-two-rounded"
                      href="/service-detail/material-testing-services-soil"
                    >
                      learn more
                    </a>
                  </div>
                  <div className="block-bg">
                    <img src={service_block_shape} alt="Image" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 wow fadeInUp"
              data-wow-delay="300ms"
              data-wow-duration="1500ms"
            >
              <div className="service-block-two">
                <div className="inner-box border-0">
                  <div className="icon">
                    <svg
                      width={96}
                      height={96}
                      viewBox="0 0 96 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 78H78L64 20H32L18 78Z"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M48 24V78"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                        strokeDasharray="8 8"
                      />
                    </svg>
                  </div>
                  <div className="content-box">
                    <h4 className="title">
                      Material Testing Services – Asphalt
                    </h4>
                    <p className="text text-clamp-3">
                      Asphalt is a critical material for roads, pavements, and
                      airport runways, where durability, performance, and safety
                      are paramount. Asphalt Material Testing must verify that
                      asphalt mixtures and pavements meet design specifications
                      and perform reliably under traffic, environmental, and
                      climatic conditions.
                    </p>
                    <a
                      className="btn-two-rounded"
                      href="/service-detail/material-testing-services-asphalt"
                    >
                      learn more
                    </a>
                  </div>
                  <div className="block-bg">
                    <img src={service_block_shape} alt="Image" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 wow fadeInUp"
              data-wow-delay="400ms"
              data-wow-duration="1500ms"
            >
              <div className="service-block-two">
                <div className="inner-box">
                  <div className="icon">
                    <svg
                      width={96}
                      height={96}
                      viewBox="0 0 96 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24 24H72V72H24V24Z"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M24 48H72"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M48 24V72"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M24 24L72 72"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="content-box">
                    <h4 className="title">
                      Material Testing Services – Concrete
                    </h4>
                    <p className="text text-clamp-3">
                      Concrete is one of the most widely used construction
                      materials, and its performance directly affects the
                      strength, durability, and service life of structures.
                      Concrete Material Testing must verify that concrete used
                      in construction meets the specified design strength,
                      quality, and durability requirements.
                    </p>
                    <a
                      className="btn-two-rounded"
                      href="/service-detail/material-testing-services-concrete"
                    >
                      learn more
                    </a>
                  </div>
                  <div className="block-bg">
                    <img src={service_block_shape} alt="Image" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 wow fadeInUp"
              data-wow-delay="500ms"
              data-wow-duration="1500ms"
            >
              <div className="service-block-two">
                <div className="inner-box">
                  <div className="icon">
                    <svg
                      width={96}
                      height={96}
                      viewBox="0 0 96 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 30H76"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M20 48H76"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M20 66H76"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M30 20V76"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M66 20V76"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="content-box">
                    <h4 className="title">Material Testing Services – Steel</h4>
                    <p className="text text-clamp-3">
                      Steel is a critical construction material used in
                      buildings, bridges, industrial structures, and
                      infrastructure projects. Its mechanical and chemical
                      properties directly change the strength, durability, and
                      safety of structures. Steel Material Testing must verify
                      that steel products meet design specifications, quality
                      standards, and regulatory requirements.
                    </p>
                    <a
                      className="btn-two-rounded"
                      href="/service-detail/material-testing-services-steel"
                    >
                      learn more
                    </a>
                  </div>
                  <div className="block-bg">
                    <img src={service_block_shape} alt="Image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SubServices